<script setup lang="ts">
import type { Item } from '@autobid/ui/types/Applications'
import { useFormGroupItem } from '@autobid/nuxt-pinia-store/store/searchStore/useFormGroupItem'
import Checkbox from '@autobid/ui/components/elements/checkbox/Checkbox.vue'

const props = defineProps<{ app: Item }>()

const checked = useFormGroupItem('appId', props.app.id)
</script>

<template>
  <Checkbox
    :checked="checked"
    :label="app.name"
    :name="app.name"
    @change="checked = !checked"
  />
</template>
